import React from "react";

function Equipment(props) {
  //TODO: Add images here instead of just text
  //      Refactor and use ItemDisplay component
  return (
    <div>
      <h3> Equipment </h3>
      <div> Head: {props.equipment.head ? props.equipment.head.name : 'None'}</div>
      <div> Arms: {props.equipment.arms ? props.equipment.arms.name : 'None'}</div>
      <div> Chest: {props.equipment.chest ? props.equipment.chest.name : 'None'}</div>
      <div> Feet: {props.equipment.feet ? props.equipment.feet.name : 'None'}</div>
      <div> Main Hand: {props.equipment.mainHand ? props.equipment.mainHand.name : 'None'}</div>
      <div> Off Hand: {props.equipment.offHand ? props.equipment.offHand.name : 'None'}</div>
    </div>
  );
}

export default Equipment;
